import React from 'react';
import GenericSelect from '../../../../../components/common/GenericSelect';
import { FilterTypes } from '@digitalexperience/dealer-website-core';
import { includes } from 'lodash';

const EmissionNormFilter = ({ filterData, filterValues, filterAdd, filterDelete }) => {
  const handleChange = (data) => {
    if (includes(filterValues, data.value)) {
      filterDelete(FilterTypes.euroNorm, data.value);
    } else {
      filterAdd(FilterTypes.euroNorm, data.value);
    }
  };

  return (
    <React.Fragment>
      <div className='builder-font-semibold builder-mb-2 builder-mt-5'>Emission norm</div>
      <GenericSelect placeHolder='All' items={filterData} values={filterValues} handleFilterChanged={handleChange} />
    </React.Fragment>
  );
};

export default EmissionNormFilter;
